export default __webpack_public_path__ + "media/icons/Concierge@2x-83d1b252.svg";